import clsx from 'clsx';
import { ChevronDownIcon } from '../../icons';
import styles from '../Select.module.css';

export function SelectTrigger({
  id,
  buttonRef,
  listboxId,
  ariaLabel,
  open,
  selectedLabel,
  disabled = false,
  valueClassName = '',
  chevronClassName = '',
  triggerClassName = '',
  useActiveFieldStyle = true,
  invalid = false,
  onClick,
  onKeyDown,
}) {
  return (
    <button
      id={id}
      ref={buttonRef}
      type="button"
      className={clsx(
        styles.trigger,
        triggerClassName,
        open && useActiveFieldStyle && styles.triggerOpen,
        invalid && styles.triggerInvalid,
      )}
      aria-label={ariaLabel}
      aria-haspopup="listbox"
      aria-expanded={open}
      aria-controls={open ? listboxId : undefined}
      aria-invalid={invalid ? 'true' : undefined}
      disabled={disabled}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <span className={clsx(styles.value, valueClassName)}>{selectedLabel}</span>
      <ChevronDownIcon
        className={clsx(styles.chevron, open && styles.chevronOpen, chevronClassName)}
        aria-hidden
      />
    </button>
  );
}
